/* Nebula banner carousel – sections/nb-banner-carousel.liquid
   Ported from the two custom scripts that drove the PageFly banners
   ("Dragability Feature" for desktop, "Carousel Banner Mobile" for mobile):
   - endless loop: [copy of last] [real banners] [copy of first], silently jumping back after landing on a copy
   - autoplay; paused while the tab is hidden, while touching/pressing, (optionally) while hovered
     and while scrolled out of view
   - arrows glide one banner; touch swipes scroll natively and snap; mouse drag over 60px changes banner
   - a drag never follows the banner link
   - height follows the current banner image
   - optional GA banner_impression / banner_click events (gtag + dataLayer, as before) */
(function () {
  if (window.NebulaBannerCarousel) return;

  var THRESHOLD = 60; // px dragged to change slide
  var SLOP = 5;       // px before a press counts as a drag

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function sendEvent(name, link, label) {
    var data = {
      banner_name: link.getAttribute('data-track-name'),
      banner_class: link.getAttribute('data-track-class') || '',
      event_category: 'Banner',
      event_label: label
    };
    if (typeof window.gtag === 'function') window.gtag('event', name, data);
    window.dataLayer = window.dataLayer || [];
    var push = { event: name };
    for (var k in data) push[k] = data[k];
    window.dataLayer.push(push);
  }

  function setupTracking(root) {
    qsa(root, '.nbc__slide:not([data-clone]) [data-track-name]').forEach(function (link) {
      if (link.__nbcTracked) return;
      link.__nbcTracked = true;
      link.addEventListener('click', function () { sendEvent('banner_click', link, 'Click Through'); });
      if (!window.IntersectionObserver) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sendEvent('banner_impression', link, 'Impression');
            io.unobserve(link);
          }
        });
      }, { threshold: 0.5 });
      io.observe(link);
    });
  }

  function init(root) {
    if (root.__nbc) return root.__nbc;
    var s = root.querySelector('.nbc__track');
    if (!s) return null;

    setupTracking(root);

    var real = qsa(s, ':scope > .nbc__slide');
    var n = real.length;
    var api = { goTo: function () {}, pause: function () {}, resume: function () {}, destroy: function () {} };
    root.__nbc = api;
    if (n < 2) return api;

    var AUTOPLAY = root.getAttribute('data-autoplay') !== 'false';
    var DELAY = parseInt(root.getAttribute('data-delay'), 10) || 5000;
    var HOVER_PAUSE = root.getAttribute('data-hover-pause') === 'true';
    var OFFSCREEN_PAUSE = root.getAttribute('data-offscreen-pause') === 'true';

    function makeClone(src) {
      var c = src.cloneNode(true);
      c.setAttribute('data-clone', '1');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      qsa(c, '[id]').forEach(function (el) { el.removeAttribute('id'); });
      qsa(c, '[data-track-name]').forEach(function (el) { el.removeAttribute('data-track-name'); });
      qsa(c, 'a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      qsa(c, 'img').forEach(function (img) { img.setAttribute('fetchpriority', 'low'); });
      return c;
    }

    // Layout: [copy of last] [real slides...] [copy of first]
    s.insertBefore(makeClone(real[n - 1]), real[0]);
    s.appendChild(makeClone(real[0]));

    var all = qsa(s, ':scope > .nbc__slide'); // length n + 2, real slides are 1..n
    var cur = 1;

    var ac = window.AbortController ? new AbortController() : null;
    var sig = ac ? { signal: ac.signal } : false;

    function pos(el) {
      return el.getBoundingClientRect().left - s.getBoundingClientRect().left + s.scrollLeft;
    }
    function nearest() {
      var left = s.getBoundingClientRect().left, best = 0, bestDist = Infinity;
      all.forEach(function (el, i) {
        var d = Math.abs(el.getBoundingClientRect().left - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function jump(i) {
      s.style.scrollBehavior = 'auto';
      s.style.scrollSnapType = 'none';
      s.scrollLeft = pos(all[i]);
      void s.offsetWidth;
      s.style.scrollSnapType = '';
      s.style.scrollBehavior = '';
    }
    function glide(i) {
      s.scrollTo({ left: pos(all[i]), behavior: 'smooth' });
    }
    function norm() {
      var i = nearest();
      if (i === 0) { jump(n); return n; }
      if (i === n + 1) { jump(1); return 1; }
      return i;
    }
    function fit(i) {
      var media = all[i].querySelector('.nbc__media');
      if (!media || !s.offsetWidth) return;
      var h = media.getBoundingClientRect().height;
      if (h > 20) s.style.height = Math.round(h) + 'px';
    }

    // Videos: posters are only set once this carousel is actually on screen (so the hidden
    // desktop/mobile copy downloads nothing); only the current banner's video plays.
    var videos = qsa(s, 'video');
    var playing = null;
    function prepVideos() {
      if (!s.offsetWidth) return;
      videos.forEach(function (v) {
        var p = v.getAttribute('data-poster');
        if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
      });
    }
    function waitVideo(i) {
      var v = all[i] && all[i].querySelector('video[data-wait-video]');
      return v && !v.__failed ? v : null;
    }
    function videoAt(i) {
      return all[i] ? all[i].querySelector('video') : null;
    }
    // Start downloading a video before its banner comes up, so it plays straight away
    function warm(i) {
      var v = videoAt(i);
      if (!v || !s.offsetWidth) return;
      prepVideos();
      if (v.preload !== 'auto') {
        v.preload = 'auto';
        if (v.readyState === 0) { try { v.load(); } catch (e) {} }
      }
    }
    // Some browsers (e.g. iPhone Low Power Mode) block autoplay until the visitor touches the page.
    // When that happens, try again on the first tap/click/key press anywhere.
    var waitingForGesture = false;
    function retryOnGesture() {
      if (waitingForGesture) return;
      waitingForGesture = true;
      var evs = ['pointerdown', 'touchstart', 'keydown', 'click'];
      function go2() {
        evs.forEach(function (n) { document.removeEventListener(n, go2, true); });
        waitingForGesture = false;
        playing = null;
        playAt(cur);
      }
      evs.forEach(function (n) { document.addEventListener(n, go2, { capture: true, passive: true }); });
    }
    function playAt(i, keep) {
      var v = videoAt(i);
      if (!keep) videos.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      if (!v) { if (!keep) playing = null; return; }
      if (!s.offsetWidth || document.hidden) return;
      v.muted = true;            // required for autoplay
      v.defaultMuted = true;
      if (playing !== v) {
        if (v.hasAttribute('data-wait-video') && (v.ended || v.currentTime > 0)) { try { v.currentTime = 0; } catch (e) {} }
        warm(i);
      }
      playing = v;
      var p = v.play();
      if (p && p.then) p.then(function () {
        if (v.__failed) { v.__failed = false; schedule(); }
      }, function (err) {
        // An AbortError just means we paused it ourselves by moving on.
        if (err && err.name === 'AbortError') return;
        // Autoplay blocked: show the still image, fall back to the normal timer, retry on first touch.
        v.__failed = true;
        schedule();
        retryOnGesture();
      });
    }
    function playCurrent() {
      playAt(cur);
      // Get the neighbouring banners' videos ready
      warm(cur + 1);
      warm(cur - 1);
    }
    videos.forEach(function (v) {
      v.addEventListener('loadedmetadata', function () { if (v.closest('.nbc__slide') === all[cur]) fit(cur); });
      v.addEventListener('error', function () { v.__failed = true; schedule(); }, true);
      if (v.hasAttribute('data-wait-video')) {
        v.addEventListener('ended', function () { if (v.closest('.nbc__slide') === all[cur]) tick(); });
      }
    });

    function mark(i) {
      cur = i;
      all.forEach(function (el, k) {
        var clone = el.hasAttribute('data-clone');
        el.classList.toggle('is-current', k === i);
        el.setAttribute('aria-hidden', clone || k !== i ? 'true' : 'false');
        qsa(el, 'a').forEach(function (a) {
          if (clone || k !== i) a.setAttribute('tabindex', '-1'); else a.removeAttribute('tabindex');
        });
      });
      fit(i);
      playCurrent();
    }

    var pressing = false, pressAt = 0, dragging = false, moved = false, suppress = false, busy = false;
    var touching = false, hover = false, inView = true, held = false;
    var startX = 0, startScroll = 0, startI = 0, dx = 0;
    var settleTimer, busyTimer, autoTimer, ro, io;

    function alive() { return document.body.contains(s); }

    function lock() {
      busy = true;
      clearTimeout(busyTimer);
      busyTimer = setTimeout(function () { busy = false; }, 1000);
    }

    function schedule() {
      clearTimeout(autoTimer);
      if (!AUTOPLAY) return;
      // "Play once and move on": the video's 'ended' event advances instead of the timer
      var v = waitVideo(cur);
      if (v && !v.ended && s.offsetWidth && !document.hidden) return;
      autoTimer = setTimeout(tick, DELAY);
    }
    function tick() {
      if (!alive()) return;
      // Safety: a press that never released would block autoplay forever
      if (pressing && Date.now() - pressAt > 15000) { pressing = false; dragging = false; }
      if (document.hidden || held || hover || pressing || touching || busy || !inView || !s.offsetWidth) { schedule(); return; }
      go(1);
    }
    function go(dir) {
      if (busy || !s.offsetWidth) return;
      var i = norm();
      lock();
      glide(i + dir);
      playAt(i + dir, true); // start the incoming video as it slides in, not after
      schedule();
    }

    // Runs after scrolling stops: if we landed on a copy, jump to the real slide
    function settle() {
      if (!alive() || pressing || touching || !s.offsetWidth) return;
      var i = norm();
      busy = false;
      clearTimeout(busyTimer);
      mark(i);
      schedule();
    }

    function cancelDrag() {
      pressing = false;
      dragging = false;
      moved = false;
      s.classList.remove('is-dragging');
      s.style.scrollSnapType = '';
      s.style.scrollBehavior = '';
    }

    s.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 120);
    }, { passive: true });

    var nextBtn = root.querySelector('[data-nbc-next]');
    var prevBtn = root.querySelector('[data-nbc-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(-1); });

    if (HOVER_PAUSE) {
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; schedule(); } });
    }

    // Touch: the browser scrolls natively; just hold autoplay and normalise once momentum stops
    s.addEventListener('touchstart', function () {
      touching = true;
      clearTimeout(autoTimer);
    }, { passive: true });
    function touchDone() {
      touching = false;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 150);
    }
    s.addEventListener('touchend', touchDone, { passive: true });
    s.addEventListener('touchcancel', touchDone, { passive: true });

    // Mouse drag
    s.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pressing = true;
      pressAt = Date.now();
      startI = norm();
      startX = e.clientX;
      startScroll = s.scrollLeft;
      dx = 0; moved = false; dragging = true;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < SLOP) return;
        moved = true;
        s.classList.add('is-dragging');
        s.style.scrollSnapType = 'none';
        s.style.scrollBehavior = 'auto';
      }
      s.scrollLeft = startScroll - dx;
    }, sig);
    function endPress() {
      if (!pressing) return;
      pressing = false;
      if (!dragging) return;
      dragging = false;
      if (!moved) return;

      suppress = true;
      setTimeout(function () { suppress = false; }, 0);

      s.classList.remove('is-dragging');
      s.style.scrollSnapType = '';
      s.style.scrollBehavior = '';

      var step = dx < -THRESHOLD ? 1 : dx > THRESHOLD ? -1 : 0;
      lock();
      glide(startI + step);
      if (step) playAt(startI + step, true);
      schedule();
    }
    window.addEventListener('pointerup', endPress, sig);
    window.addEventListener('pointercancel', endPress, sig);

    // Don't follow the banner link after a drag
    s.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    s.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Keyboard: move focus into a banner -> show it
    s.addEventListener('focusin', function (e) {
      var slide = e.target.closest('.nbc__slide');
      var i = all.indexOf(slide);
      if (i > 0 && i <= n && i !== cur) { jump(i); mark(i); }
    });

    // Keep alignment on resize and when the carousel becomes visible (e.g. crossing 1025px)
    function realign() {
      if (!alive()) return;
      if (!s.offsetWidth) { videos.forEach(function (v) { if (!v.paused) v.pause(); }); return; }
      prepVideos();
      jump(cur);
      fit(cur);
      playCurrent();
    }
    if (window.ResizeObserver) {
      ro = new ResizeObserver(realign);
      ro.observe(s);
    } else {
      window.addEventListener('resize', realign, sig);
    }
    // Height must be re-measured once lazy images arrive
    qsa(s, 'img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { if (img.closest('.nbc__slide') === all[cur]) fit(cur); });
    });

    if (OFFSCREEN_PAUSE && window.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.1 });
      io.observe(s);
    }

    document.addEventListener('visibilitychange', function () {
      if (!alive()) return;
      if (document.hidden) {
        clearTimeout(autoTimer);
        cancelDrag();
        hover = false;
        videos.forEach(function (v) { if (!v.paused) v.pause(); });
        return;
      }
      settle();
      schedule();
    }, sig);

    prepVideos();
    jump(cur);
    mark(cur);
    schedule();

    api.goTo = function (realIndex) {
      var i = Math.min(Math.max(realIndex, 0), n - 1) + 1;
      jump(i);
      mark(i);
    };
    api.pause = function () { held = true; clearTimeout(autoTimer); };
    api.resume = function () { held = false; schedule(); };
    api.destroy = function () {
      if (ac) ac.abort();
      clearTimeout(settleTimer);
      clearTimeout(busyTimer);
      clearTimeout(autoTimer);
      if (ro) ro.disconnect();
      if (io) io.disconnect();
      root.__nbc = null;
    };
    return api;
  }

  function initAll(scope) {
    qsa(scope || document, '[data-nbc]').forEach(init);
  }

  window.NebulaBannerCarousel = { init: init, initAll: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    qsa(e.target, '[data-nbc]').forEach(function (root) { if (root.__nbc) root.__nbc.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-nbc]');
    if (!root || !root.__nbc) return;
    root.__nbc.pause();
    root.__nbc.goTo(parseInt(e.target.getAttribute('data-index'), 10) || 0);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-nbc]');
    if (root && root.__nbc) root.__nbc.resume();
  });
})();
